import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor() {}

  set(key: string, data: any): void {
    try {
      const oldData = JSON.parse(localStorage.getItem(key)) || {};
      const newKey = Object.keys(data)[0]
      const newValue = Object.values(data)[0]

      oldData[newKey] = newValue;

      localStorage.setItem(key, JSON.stringify(oldData));
      
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  get(key: string) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }
}
